/**
 * Standard app dialog — header + scrollable body + footer.
 * All admin popups should use this so tall content scrolls correctly.
 */
export default function AppModal({
  open,
  onClose,
  title,
  size = "md",
  footer,
  footClassName = "",
  stacked = false,
  children,
}) {
  if (!open) return null;

  const sizeClass =
    size === "sm" ? "bw-modal--sm" : size === "lg" ? "bw-modal--lg" : "bw-modal--md";

  return (
    <div
      className={`bw-modal-backdrop${stacked ? " bw-modal-backdrop--stacked" : ""}`}
      onMouseDown={onClose}
    >
      <div
        className={`bw-modal ${sizeClass}`}
        role="dialog"
        aria-modal="true"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <header className="bw-modal-head">
          <h2 className="bw-modal-title">{title}</h2>
          <button type="button" className="bw-modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </header>
        <div className="bw-modal-body">{children}</div>
        {footer != null && (
          <footer className={`bw-modal-foot${footClassName ? ` ${footClassName}` : ""}`}>
            {footer}
          </footer>
        )}
      </div>
    </div>
  );
}
